import { styled } from 'libs/ui/styled';

export const WrapperStyled = styled('div')({
  '--margin-horizontal': `32px`,
  paddingLeft: 'var(--margin-horizontal)',
  paddingRight: 'var(--margin-horizontal)',
});
